// Testimonials Slider
class TestimonialsSlider {
    constructor() {
        this.slider = document.querySelector('[data-testimonials-slider]');
        this.slides = this.slider ? this.slider.querySelector('.testimonials__slides') : null;
        this.items = document.querySelectorAll('.testimonials__item');
        this.navButtons = document.querySelectorAll('.testimonials__nav-btn');
        this.prevBtn = document.querySelector('.testimonials__btn--prev');
        this.nextBtn = document.querySelector('.testimonials__btn--next');
        this.currentSlide = 0;
        this.isDragging = false;
        this.startX = 0;
        this.currentX = 0;
        this.dragThreshold = 100; // Minimum drag distance to change slide
        this.realSlidesCount = this.items.length;
        this.isTransitioning = false;
        this.slideWidth = 0;
        this.needsJump = false;

        if (this.slider && this.realSlidesCount > 1) {
            this.init();
        }
    }

    init() {
        console.log('TestimonialsSlider initialized, items:', this.items.length, 'buttons:', this.navButtons.length);
        this.duplicateSlides();
        this.slideWidth = this.slider.offsetWidth;
        this.bindEvents();
        this.slides.addEventListener('transitionend', () => {
            if (this.needsJump) {
                this.needsJump = false;
                this.isTransitioning = false;
                if (this.currentSlide === 0) {
                    this.goToSlide(this.realSlidesCount, false);
                } else if (this.currentSlide === this.realSlidesCount + 1) {
                    this.goToSlide(1, false);
                }
            }
        });
        this.goToSlide(1, false); // Start at first real slide
        window.addEventListener('resize', () => {
            this.slideWidth = this.slider.offsetWidth;
            this.goToSlide(this.currentSlide, false);
        });
    }

    duplicateSlides() {
        if (!this.slides) return;

        // Clone first and last slides for infinite scroll
        const firstClone = this.items[0].cloneNode(true);
        const lastClone = this.items[this.realSlidesCount - 1].cloneNode(true);

        firstClone.classList.add('clone');
        lastClone.classList.add('clone');

        // Append first clone as last, prepend last clone as first
        this.slides.appendChild(firstClone);
        this.slides.insertBefore(lastClone, this.items[0]);

        // Update items to include clones
        this.items = this.slides.querySelectorAll('.testimonials__item');
        console.log('Slides duplicated, total items:', this.items.length);
    }

    bindEvents() {
        console.log('Binding events for testimonials slider');
        this.navButtons.forEach((btn, index) => {
            console.log('Binding nav button', index);
            btn.addEventListener('click', () => {
                console.log('Nav button clicked', index);
                this.goToSlide(index + 1);
            });
        });

        if (this.prevBtn) {
            console.log('Binding prev button');
            this.prevBtn.addEventListener('click', () => {
                console.log('Prev button clicked');
                this.prevSlide();
            });
        }
        if (this.nextBtn) {
            console.log('Binding next button');
            this.nextBtn.addEventListener('click', () => {
                console.log('Next button clicked');
                this.nextSlide();
            });
        }

        // Touch events for swipe
        this.slider.addEventListener('touchstart', (e) => {
            this.startDrag(e.touches[0].clientX);
        });
        this.slider.addEventListener('touchmove', (e) => {
            if (this.isDragging) {
                e.preventDefault();
                this.drag(e.touches[0].clientX);
            }
        });
        this.slider.addEventListener('touchend', () => {
            this.endDrag();
        });

        // Mouse events for drag
        this.slider.addEventListener('mousedown', (e) => {
            this.startDrag(e.clientX);
        });
        document.addEventListener('mousemove', (e) => {
            if (this.isDragging) {
                e.preventDefault();
                this.drag(e.clientX);
            }
        });
        document.addEventListener('mouseup', () => {
            this.endDrag();
        });
    }

    startDrag(x) {
        this.isDragging = true;
        this.startX = x;
        this.currentX = x;
        this.slider.style.cursor = 'grabbing';
    }

    drag(x) {
        this.currentX = x;
        let diff = this.startX - this.currentX;
        // Limit diff to prevent showing clones
        if (this.currentSlide === this.realSlidesCount) {
            diff = Math.min(diff, 0);
        } else if (this.currentSlide === 1) {
            diff = Math.max(diff, 0);
        }
        diff = Math.max(-this.slideWidth * 0.5, Math.min(this.slideWidth * 0.5, diff));
        if (this.slides) {
            this.slides.style.transform = `translateX(${-this.currentSlide * this.slideWidth - diff}px)`;
        }
    }

    endDrag() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.slider.style.cursor = 'grab';

        const diff = this.startX - this.currentX;
        if (Math.abs(diff) > this.dragThreshold) {
            if (diff > 0) {
                this.nextSlide(); // Swiped left -> next
            } else {
                this.prevSlide(); // Swiped right -> prev
            }
        } else {
            this.goToSlide(this.currentSlide, false); // Reset to current slide without animation
        }
    }

    goToSlide(index, animate = true) {
        if (this.isTransitioning) return;
        console.log('Going to slide:', index, 'animate:', animate);

        // Mark for jump if at clone
        if (index === 0 || index === this.realSlidesCount + 1) {
            this.needsJump = true;
        }

        if (animate) {
            this.slides.style.transition = 'transform var(--transition-slow)';
        } else {
            this.slides.style.transition = 'none';
        }

        if (this.slides) {
            this.slides.style.transform = `translateX(-${index * this.slideWidth}px)`;
        }

        // Update nav buttons for real slides (1 to realSlidesCount)
        const realIndex = index === 0 ? this.realSlidesCount - 1 : index === this.realSlidesCount + 1 ? 0 : index - 1;
        this.navButtons.forEach((btn, i) => {
            btn.classList.toggle('testimonials__nav-btn--active', i === realIndex);
        });

        this.currentSlide = index;
        this.isTransitioning = animate;
        if (animate && !this.needsJump) {
            setTimeout(() => {
                this.isTransitioning = false;
            }, 200);
        }
    }

    nextSlide() {
        this.goToSlide(this.currentSlide + 1);
    }

    prevSlide() {
        this.goToSlide(this.currentSlide - 1);
    }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
    new TestimonialsSlider();
});